import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { PatientUnavailableServices } from '@common/interfaces/patientUnavailableServices';
import { FoundPatientStatus } from '@common/enums/foundPatientStatus';
import type { IPatientInOrganization } from './PatientSearch';
import type { IPatientSearchResult } from './PatientSearchStartBar';
import type { IVecozoInsurance } from './searchPatientFunctions';
import { emptyPatient } from './emptyPatient';

export enum SearchType {
    extraInformationBar = 'extraInformationBar',
    startBar = 'startBar',
    startBarOnlyInOrganization = 'startBarOnlyInOrganization',
}

export type NewPatient = { insurance?: IVecozoInsurance; patient: IPatientSearchResult } | null;

interface ISearchContextProps {
    duplicatePatientId?: string;
    foundPatientStatus: FoundPatientStatus;
    isSearching: boolean;
    message?: string;
    newPatient: NewPatient;
    patient: IPatientSearchResult;
    patients: (IPatientInOrganization | IPatientSearchResult)[];
    search: (type: SearchType, updatedPatient?: IPatientSearchResult) => void;
    setDuplicatePatientId: Dispatch<SetStateAction<string | undefined>>;
    setFoundPatientStatus: Dispatch<SetStateAction<FoundPatientStatus>>;
    setNewPatient: Dispatch<SetStateAction<NewPatient>>;
    setPatient: Dispatch<SetStateAction<IPatientSearchResult>>;
    setPatients: Dispatch<SetStateAction<(IPatientInOrganization | IPatientSearchResult)[]>>;
    setUnavailableServices: Dispatch<SetStateAction<PatientUnavailableServices>>;
    total: number;
    unavailableServices?: PatientUnavailableServices;
}

export const PatientSearchContext = createContext<ISearchContextProps>({
    duplicatePatientId: undefined,
    foundPatientStatus: FoundPatientStatus.noSearch,
    isSearching: false,
    message: undefined,
    newPatient: null,
    patient: emptyPatient(),
    patients: [],
    search: () => undefined,
    setDuplicatePatientId: () => undefined,
    setFoundPatientStatus: () => undefined,
    setNewPatient: () => undefined,
    setPatient: () => undefined,
    setPatients: () => [],
    setUnavailableServices: () => undefined,
    total: 0,
    unavailableServices: undefined,
});
